<style scoped>
    .edit-wrapper{
        max-width: 960px;
        margin: 0 auto;
    }
    .edit-label{
        display: inline-block;
        vertical-align: top;
        padding: 2px 0;
    }
    .fill-info{
        border-bottom: 1px solid #dddee1;
    }
    .job-content-selector{
        width: 100%;
    }
    .job-content-selector /deep/ .ivu-poptip-rel{
        width: 100%;
    }
    .ivu-cell{
        padding: 3px 5px;
    }
    .job-content-selector-content{
        height: 150px;
    }
    .checkbox-wrapper{
        border-radius: 4px;
        border: 1px solid #dcdee2;
        padding: 6px;
        line-height: 18px;
    }
    .edit-wrapper /deep/ .ivu-form-item{
        margin-bottom: 5px;
    }
    .customer-selector{
        width: auto !important;
    }
</style>
<template>
  <div>
    <VModel
      v-model="edit_config.modal"
      fullscreen
      persistent
      :show-header-close="false"
      :loading="edit_config.loading"
      title="合同申请"
      ok-text="保存"
      @ok="setContractOK"
    >
      <Form
        ref="form"
        :model="edit_contract" 
        class="edit-wrapper"
        :label-width="100"
      >
        <Row>
          <i-col span="6">
            <FormItem
              prop="apply_user_id"
              :rules="{required: true,validator:baseValidator('申请人必选'), trigger: 'blur'}"
            >
              <span class="edit-label">申请人:</span>
              <CustomerSelector
                v-model="edit_contract.apply_user_id"
                class="customer-selector"
                type="text"
                size="small"
                :disabled="cannot_edit"
                @on-change="setApplyUser"
              >
                <span v-if="edit_contract.apply_user">{{ edit_contract.apply_user }}</span>
                <span
                  v-else
                  class="link"
                >请选择</span>
              </CustomerSelector>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem
              prop="pay_user_id"
              :rules="{required: true,validator:baseValidator('负责人必选'), trigger: 'blur'}"
            >
              <span class="edit-label">
                负责人
                <Tooltip content="负责每月为兼职外包人员发放工资">
                  <Icon
                    type="md-alert"
                    size="18"
                    style="transform: translate(-3px, 1px);"
                  />:
                </Tooltip>
              </span>
              <CustomerSelector
                v-model="edit_contract.pay_user_id"
                class="customer-selector"
                type="text"
                size="small"
                :url="query_formal_path"
                :disabled="cannot_edit"
                @on-change="setPayUser"
              >
                <span v-if="edit_contract.pay_user">{{ edit_contract.pay_user }}</span>
                <span
                  v-else
                  class="link"
                >请选择</span>
              </CustomerSelector>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem
              prop="fill_user"
              :rules="{required: true,validator:baseValidator('填制人必选'), trigger: 'blur'}"
            >
              <span class="edit-label">填制人:</span>
              <Button
                type="text"
                size="small"
                disabled
              >
                {{ edit_contract.fill_user }}
              </Button>
            </FormItem>
          </i-col>
          <i-col span="6">
            <span class="edit-label">编码:</span>
            <Button
              type="text"
              size="small"
              disabled
            >
              <span v-if="edit_contract.uid">{{ edit_contract.uid }}</span>
              <span v-else>保存后自动生成</span>
            </Button>
          </i-col>
        </Row>
        <div class="line text-center">
          <h3>签约形式</h3>
          <Row
            :gutter="8"
          >
            <i-col span="12">
              <FormItem label="签约形式">
                <div style="text-align: left;">
                  <!-- <RadioGroup v-model="edit_contract.is_electronic">
                    <Radio :value="true">
                      电子合同
                    </Radio>
                    <Radio :value="false">
                      纸质合同
                    </Radio>
                  </RadioGroup> -->
                  <i-switch
                    v-model="edit_contract.is_electronic"
                    @on-change="changeContractE"
                  />
                  <span style="margin-left:10px">[{{ edit_contract.is_electronic ?'电子合同':'纸质合同' }}]</span>
                </div>
              </FormItem>
            </i-col>
          </Row>
        </div>
        <div class="line text-center">
          <h3>基本信息</h3>
          <Row>
            <i-col span="16">
              <div style="height:50px">
                <FormItem 
                  prop="account"
                  :rules="{required: true,validator:baseValidator('对方姓名必填'), trigger: 'blur'}"
                  label="对方姓名"
                >
                  <i-input
                    v-model="edit_contract.account"
                    :disabled="cannot_edit"
                    placeholder="保持和身份证或护照名字一致"
                    @on-change="trimSpace('account')"
                  />
                </FormItem>
              </div>
            </i-col>
            <i-col span="8">
              <FormItem label="人口地区属性">
                <Select
                  v-model="edit_contract.region"
                  placeholder="人口地区属性"
                >
                  <Option value="mainland">
                    中国大陆人士
                  </Option>
                  <Option value="hongkond_macau_taiwan">
                    中国港澳台人士
                  </Option>
                  <Option value="foreign">
                    外国人士
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <!-- </Row>
          <Row
           
            :gutter="8"
          > -->
            <i-col span="8">
              <FormItem
                prop="mobile"
                label="联系电话"
                :rules="{required: edit_contract.is_electronic, validator:(...arg)=> validateCustom('mobile',...arg) }"
              >
                <i-input
                  v-model="edit_contract.mobile"
                  placeholder="国外号码请包含国际区号"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="证件号码">
                <i-input
                  v-model="edit_contract.id_number"
                  :disabled="cannot_edit"
                  placeholder="不要留空格"
                  @on-change="stripSpace('id_number')"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="合同签署公司">
                <Select
                  v-model="edit_contract.company_id"
                  placeholder="合同签署公司"
                >
                  <Option
                    v-for="company in companies"
                    :key="company.id"
                    :value="company.id"
                  >
                    {{ company.short_name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
          </Row>
          <!-- <div class="line text-center">
            <h3>科目信息</h3>
            <Row
              v-if="is_financer"
         
              :gutter="8"
            >
              <i-col span="8">
                <FormItem label="费用nature">
                  <Select
                    v-model="edit_contract.expense_nature_id"
                    filterable
                    clearable
                    @on-change="calcAccountAndAnalysisTitle('expense_nature_id')"
                  >
                    <Option
                      v-for="item in expense_natures"
                      :key="item.id"
                      :value="item.id"
                      :disabled="item.del || !expenseNatureMapped(item)"
                    >
                      {{ expenseNatureText(item) }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col> 
     
              <i-col span="8">
                <FormItem label="人员属性">
                  <Select
                    v-model="edit_contract.customer_type"
                    :disabled="!filter_customer_types.length"
                    filterable
                    clearable
                    @on-change="calcAccountAndAnalysisTitle('customer_type')"
                  >
                    <Option
                      v-for="item in filter_customer_types"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col> 
              <i-col span="8">
                <FormItem label="产品类型">
                  <Select
                    v-model="edit_contract.item_type_id"
                    :disabled="!filter_item_types.length"
                    filterable
                    clearable
                    @on-change="calcAccountAndAnalysisTitle('item_type_id')"
                  >
                    <Option
                      v-for="item in filter_item_types"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ `${item.name}${item.del ? '(已废弃)' : ''}` }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row style="height:80px" /> 
          </div> -->
          <Row
            v-if="is_financer"
           
            :gutter="8"
          >
            <!--  <i-col span="16">
              <FormItem label="费用类别">
                <ExpenseTypeSelector
                  v-model="edit_contract.expense_type_id"
                  :transfer="true"
                >
                  <span v-if="edit_contract.expense_type_id">{{ getExpenseTypeName(edit_contract.expense_type_id) }}</span>
                  <span
                    v-else
                    class="color-grey"
                  >选择费用类别</span>
                </ExpenseTypeSelector>
              </FormItem> 
            </i-col> -->
          </Row>
        </div>
        <div class="line text-center">
          <h3>工作内容</h3>
          <Row
       
            :gutter="8"
          >
            <i-col span="8">
              <FormItem label="项目组">
                <Select
                  v-model="edit_contract.team_id"
                  :disabled="cannot_edit"
                  placeholder="项目组"
                >
                  <Option
                    v-for="team in teams"
                    v-if="!team.del"
                    :key="team.id"
                    :value="team.id"
                  >
                    {{ team.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="工作内容">
                <Poptip
                  popper-class=""
                  class="job-content-selector"
                  width="200"
                  placement="bottom"
                  
                  :disabled="(edit_contract.ads_record_ids&&!!edit_contract.ads_record_ids.length)"
                >
                  <Button long>
                    <span v-if="edit_contract.job_content">{{ edit_contract.job_content }}</span>
                    <span
                      v-else
                      class="color-grey"
                    >请选择工作内容</span>
                  </Button>
                  <div
                    slot="content"
                    class="job-content-selector-content"
                  >
                    <CellGroup
                      @on-click="setJobContent"
                    >
                      <Cell
                        name="内容创作"
                        title="内容创作"
                      />
                      <Cell
                        name="咨询服务"
                        title="咨询服务"
                      />
                      <Cell
                        name="广告推广"
                        title="广告推广"
                      />
                    </CellGroup>
                    <!-- <div class="line color-error">
                      其他请在输入框里填写
                    </div> -->
                    <!-- <i-input
                      v-model="temp_job_content"
                      size="small"
                      placeholder="其他工作内容..."
                    >
                      <Button
                        slot="append"
                        @click="setJobContent(temp_job_content)"
                      >
                        确定
                      </Button>
                    </i-input> -->
                  </div>
                </Poptip>
              </FormItem>
            </i-col>
            <i-col
              v-if="is_financer"
              span="8"
            >
              <FormItem label="职能">
                <!--     :disabled="!filter_customer_functions.length" -->
                <Select
                  v-model="edit_contract.customer_function_id"
                  filterable
                  clearable
                  @on-change="handleMap"
                >
                  <Option
                    v-for="item in filter_customer_functions"
                    :key="item.id"
                    :value="item.id"
                    :disabled="item.del"
                  >
                    {{ `${item.name}${item.del ? '(已废弃)' : ''}` }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="支付平台">
                <Select
                  v-model="edit_contract.platform"
                  placeholder="请选择支付平台"
                >
                  <Option
                    v-for="platform in platforms"
                    :key="platform.value"
                    :value="platform.value"
                  >
                    {{ platform.label }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="工作方式">
                <div class="checkbox-wrapper">
                  <Checkbox v-model="edit_contract.is_remote">
                    是否远程
                  </Checkbox>
                </div>
              </FormItem>
            </i-col>
            <i-col span="8" />
            <i-col span="8">
              <FormItem
                label="是否为量产"
                :label-width="120"
                prop="quantitative_output"
                :rules="{required: true, validator:(...arg)=> validateCustom('quantitative_output',...arg) }"
              >
                <span
                  slot="label"
                >
                
                  是否为量产
                  <Tooltip
                    placement="top"
                    content="通常由本部门课程团队申请，该兼职人员通常工作为内容制作、动画制作、插画制作、英语编辑等量产工作，且费用将计入本部门量产费用包。若不清楚，可以询问HRBP"
                  >
                    <Icon
                      type="md-help-circle"
                      size="18"
                    />
                  </Tooltip>
                </span>
                <!-- <Checkbox v-model="edit_contract.is_remote">
                  是否远程
                </Checkbox> -->
                <RadioGroup
                  v-model="edit_contract.quantitative_output"
                  @on-change="handleMap"
                >
                  <Radio
                    label="true"
                  >
                    是
                  </Radio>
                  <Radio
                    label="false"
                  >
                    否
                  </Radio>
                </RadioGroup>
              </FormItem>
            </i-col>
            <i-col
           
              span="8"
            >
              <FormItem
                v-if="hr_is_part_time_job"
                label="是否兼职"
              >
                <div style="text-align:left">
                  <Checkbox v-model="edit_contract.part_time_job">
                    <span />
                  </Checkbox>
                </div>
              </FormItem>
            </i-col>
            <i-col
              v-if="edit_contract.platform==='yunzhanghu'"
              span="8"
            >
              <FormItem label="是否为个体户">
                <div style="text-align:left">
                  <Checkbox
                    v-model="edit_contract.is_soho"
                    :disabled="!is_financer"
                  >
                    <span />
                  </Checkbox>
                </div>
              </FormItem>
            </i-col>
            <i-col
              v-if="is_financer"
              span="12"
            >
              <FormItem 
                :label-width="150"
                prop="account_title_id"
                :rules="{required: true,validator:financerValidator('会计科目必选'), trigger: 'blur'}"
                label="会计科目[自动匹配]"
              >
                <p style="font-style:italic">
                  {{ edit_contract.account_title_id&&account_leaf_titles_hash[edit_contract.account_title_id]? account_leaf_titles_hash[edit_contract.account_title_id].full_name:'-' }}
                </p>
              </FormItem>
            </i-col>
            <i-col
              v-if="is_financer"
              span="12"
            >
              <FormItem 
                :label-width="150"
                prop="analysis_title_id"
                :rules="{required: true,validator:financerValidator('分析科目必选'), trigger: 'blur'}"
                label="分析科目[自动匹配]"
              >
                <p style="font-style:italic">
                  {{ edit_contract.analysis_title_id&&analysis_titles_hash[edit_contract.analysis_title_id]? analysis_titles_hash[edit_contract.analysis_title_id].name:'-' }}
                </p>
              </FormItem>
            </i-col>
          </Row>
        </div>
        <div class="line text-center">
          <h3>支付信息</h3>
          <Row
          
            :gutter="8"
          >
            <i-col span="12">
              <FormItem label="结算方式">
                <div class="checkbox-wrapper">
                  <RadioGroup
                    v-model="edit_contract.settlement_type"
                    :disabled="cannot_edit"
                  >
                    <!-- <Radio label="by_piece">
                      按月计件
                    </Radio> -->
                    <!-- <Radio label="daily_wage">
                      按月日薪
                    </Radio> -->
                    <Radio label="per_month">
                      按月结算
                    </Radio>
                    <Radio label="per_time">
                      按次结算
                    </Radio>
                    <!-- <Radio label="other">其他</Radio> -->
                  </RadioGroup>
                </div>
              </FormItem>
            </i-col>
            <i-col span="12">
              <FormItem label="预计总金额">
                <i-input
                  v-model="edit_contract.estimate_price"
                  :disabled="cannot_edit"
                  placeholder="预估人民币总金额"
                />
              </FormItem>
            </i-col>
          </Row>
          <Row
         
            :gutter="8"
          >
            <i-col span="12">
              <FormItem label="支付方式">
                <div class="checkbox-wrapper">
                  <RadioGroup v-model="edit_contract.payment_type">
                    <Radio label="bank">
                      银行卡
                    </Radio>
                    <Radio label="alipay">
                      支付宝
                    </Radio>
                  </RadioGroup>
                </div>
              </FormItem>
            </i-col>
            <i-col span="12">
              <FormItem label="支付宝账号">
                <i-input
                  v-model="edit_contract.alipay"
                  :disabled="cannot_edit || edit_contract.payment_type != 'alipay'"
                  @on-change="stripSpace('alipay')"
                />
              </FormItem>
            </i-col>
          </Row>
          <Row
          
            :gutter="8"
          >
            <i-col span="12">
              <FormItem label="银行卡卡号">
                <i-input
                  v-model="edit_contract.bank_number"
                  :disabled="cannot_edit || edit_contract.payment_type != 'bank'"
                  placeholder="不要留空格"
                  @on-change="stripSpace('bank_number')"
                />
              </FormItem>
            </i-col>
            <i-col span="12">
              <FormItem label="银行开户行">
                <i-input
                  v-model="edit_contract.bank_branch"
                  :disabled="cannot_edit || edit_contract.payment_type != 'bank'"
                  placeholder="XX银行XX支行"
                />
              </FormItem>
            </i-col>
          </Row>
          <div class="line color-error text-left">
            <div>* 1. "按次结算"可通过MIS付款申请流程申请结算, 其他结算方式通过每月填写工资表结算.</div>
            <div>* 2. 请预估合同人民币金额. </div>
            <div>* 3. 请填写主流银行, 信用社或城市银行有可能发放失败.</div>
          </div>
        </div>
        <div class="line text-center">
          <h3>合同时效</h3>
          <Row
            
            :gutter="8"
          >
            <i-col span="8">
              <FormItem label="生效日期">
                <DatePicker
                  type="date"
                  :value="edit_contract.contract_start"
                  placeholder="生效日期"
                  @on-change="setContractStart"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="终止日期">
                <DatePicker
                  type="date"
                  :value="edit_contract.contract_end"
                  placeholder="终止日期"
                  @on-change="setContractEnd"
                />
              </FormItem>
            </i-col>
          </Row>
          <div class="line color-error text-left">
            *合同到期后将无法结算报酬
          </div>
        </div>
        <!-- <div class="line text-center">
          <PutInRecordsModal v-model="edit_contract" />
        </div> -->
        <div class="line text-center">
          <h3>附件上传</h3>
          <Row
           
            :gutter="8"
          >
            <i-col span="8">
              <EditAttachments
                :files="edit_contract.contract_files"
                model_type="OutsourceContract"
                :model_id="edit_contract.id"
              />
              <FileUploader 
                :validate-file="validateFile"
                @uploaded="uploadedContractFile"
              >
                <Icon type="ios-document-outline" />
                <span>合同附件</span>
              </FileUploader>
            </i-col>
            <i-col
              v-show="!edit_contract.is_electronic"
              span="8"
            >
              <EditAttachments
                :files="edit_contract.id_files"
                model_type="OutsourceContract"
                :model_id="edit_contract.id"
              />
              <FileUploader
                :validate-file="validateFile"
                :format="['jpg', 'jpeg', 'png', 'pdf']"
                @uploaded="uploadedIdFile"
              >
                <Icon type="md-images" />
                <span>身份证"正反面"或护照扫描件/照片</span>
              </FileUploader>
            </i-col>
            <i-col span="8">
              <EditAttachments
                :files="edit_contract.payment_files"
                model_type="OutsourceContract"
                :model_id="edit_contract.id"
              />
              <FileUploader
                :validate-file="validateFile"
                :format="['jpg', 'jpeg', 'png', 'pdf']"
                @uploaded="uploadedPaymentFile"
              >
                <Icon type="md-images" />
                <span>银行卡扫描件/照片</span>
              </FileUploader>
            </i-col>
          </Row>
        </div>
        <div class="line">
          <h3 class="line text-center">
            备注
          </h3>
          <i-input
            v-model="edit_contract.desc"
            type="textarea"
            placeholder="备注..."
          />
        </div>
      </Form>
      <Spin
        v-if="loading"
        fix
      />
    </VModel>

    <Modal
      v-model="store_file_config.modal"
      title="合同归档"
      width="700"
      :loading="store_file_config.loading"
      ok-text="保存"
      @on-ok="uploadedArchiveFileOk"
    >
      <div
        v-if="edit_contract.archive_files"
        class="line"
      >
        <EditAttachments
          :files="edit_contract.archive_files"
          model_type="OutsourceContract"
          :model_id="edit_contract.id"
        />
        <FileUploader
          :validate-file="validateFile"
          @uploaded="uploadedArchiveFile"
        >
          <Icon type="ios-paper-outline" />
          <span>上传归档文件</span>
        </FileUploader>
        <Spin
          v-show="loading"
          fix
        />
      </div>
    </Modal>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import VModel from '@/vuetify_custom/v-modal_v1'
  import TitleMappingUtil from '@/views/title_mapping/libs/util.js'
  import OSUtil from '../libs/outsource_util';
  import FlowUtil from '../../../libs/flow_util';
  import CustomerSelector from '../../components/customer/selector';
  import FileUploader from '../../components/file/uploader';
  import EditAttachments from '../../components/file/edit_attachments';
  import ExpenseTypeSelector from '../../expense_type/components/selector';
  import PutInRecordsModal from '@/views/business/components/PutInRecordsModal.jsx'
  const change_fields = [
    'expense_nature_id', 
    'customer_function_id', 
    'customer_type',
    'item_type_id',
    'fund_usage_id',
  ]
  const ill_val = [undefined, null, '']
  export default {
    components: { CustomerSelector, FileUploader, EditAttachments, ExpenseTypeSelector, VModel, PutInRecordsModal },
    data() {
      return {
        temp_job_content: '',
        edit_contract: {},
        edit_config: {
          modal: false,
          loading: false
        },
        loading: false,
        query_formal_path: Util.api.es_query_formal_customer,
        store_file_config: {
          modal: false,
          loading: true
        },
        // platforms: OSUtil.platforms
      }
    },
    computed: {
      platforms() {
        if (this.edit_contract.is_electronic) {
          return OSUtil.platforms.filter(i => i.value === 'yunzhanghu')
        }
        return OSUtil.platforms
      },
      hr_is_part_time_job() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['hr_is_part_time_job']
      },
      // mapped_expense_nature_hash() {
      //   return Object.assign({}, ...this.title_mappings.map(obj => {
      //     const key = obj['expense_nature_id'];
      //     return {[key]: true};
      //   }));
      // },
      // account_leaf_titles_title() {

      //   return this.edit_contract.account_title_id ? this.account_leaf_titles_hash[this.edit_contract.account_title_id].full_name : '未正确匹配'
      // },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters('async', {
        companies: 'companies',
        teams: 'root_teams',
        expense_types_hash: 'expense_types_hash',
        title_mappings: 'title_mappings',
        expense_natures:'expense_natures',
        customer_functions_hash: 'customer_functions_hash',
        mapping_customer_types_hash: 'mapping_customer_types_hash',
        item_types_hash: 'item_types_hash',
        account_leaf_titles: 'account_leaf_titles',
        analysis_titles: 'analysis_titles',
        account_leaf_titles_hash: 'account_leaf_titles_hash',
        analysis_titles_hash: 'analysis_titles_hash',
        outsource_contract_title_mappings: 'outsource_contract_title_mappings',
      }),
      cannot_edit() {
        return false;
        // if (!this.edit_contract.id) return false;
        // return !FlowUtil.canEdit(this.edit_contract, this.cur_customer);
      },
      is_financer() {
        return this.cur_customer.groups && this.cur_customer.groups.indexOf('GROUP_FIN') > -1;
      },
      filter_customer_functions() {
        return this.commonFilter('customer_function_id', 'customer_functions_hash');
      },
      // 员工类型
      // filter_customer_types() {
      //   return this.commonFilter('customer_type', 'mapping_customer_types_hash', [
      //     'expense_nature_id',
      //     'customer_function_id'
      //   ]);
      // },
      // 产品类型
      // filter_item_types() {
      //   return this.commonFilter('item_type_id', 'item_types_hash', [
      //     'expense_nature_id',
      //     'customer_function_id',
      //     'customer_type',
      //   ]);
      // }, 
    },
    created() {
      this.outsource_contract_title_mappings
      //
    },
    mounted() {
      //
    },
    methods: {
      handleMap() {
        const arr = ['job_content', 'customer_function_id', 'quantitative_output']
        this.edit_contract.analysis_title_id = null
        this.edit_contract.account_title_id = null
        const outsource_contract_title_mappings = this.outsource_contract_title_mappings || []
        outsource_contract_title_mappings.forEach(i => {
       
          if (arr.every(key => {
      
            return `${this.edit_contract[key]}` === `${i[key]}` 
          })) {
            this.edit_contract.analysis_title_id = i.analysis_title_id;
            this.edit_contract.account_title_id = i.account_title_id;
            this.$forceUpdate()
          }
        })
    
      },
      createRecords(params) {
        params = params || []
        setTimeout(() => {
          this.add()
          this.edit_contract.job_content = "广告推广"
          // this.edit_contract.ads_record_ids = params.map(i => i.id)
          this.$set(this.edit_contract, 'ads_record_ids', params.map(i => i.id))
        }, 500)
   
      },
      validateCustom(key, rule, value, callback) {
        let str = ''
        const validate_arr = ['', undefined, null]
       
        switch (key) {
        case 'mobile':
          if (validate_arr.includes(value) && this.edit_contract.is_electronic) {
            str = '必填'
          } 
          break;

        case 'quantitative_output':
          if (validate_arr.includes(value)) {
            str = '必选'
          } 
          break;

        default:
          break;
        }
        str ? callback(new Error(str)) : callback();
       
      },
      // 当选择电子合同时，默认云账户
      changeContractE(val) {
        if (val) {
          const a = OSUtil.platforms.filter(i => i.value === 'yunzhanghu')[0]
          this.edit_contract.platform = a.value
        }
      },
      financerValidator(msg) {
        return (rule, val, callback) => {
          if (!this.is_financer) {
            callback()
          }
          if (!val) {
            callback(new Error(msg));
            return
          }
          callback()
        }
      },
      baseValidator(msg) {
        return (rule, val, callback) => {
          if (!val) {
            callback(new Error(msg));
            return
          }
          callback()
        }
      },
      validateFile(file) {
        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
        if (!a) {
          this.$vModal.warning({
            title:'提示',
            content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
          })
        }
        return a
      },
      add() {
        this.edit_contract = Util.clone({...OSUtil.new_contract, customer_function_id:''});
        if (!this.edit_contract.id) {
          this.edit_contract.fill_user_id = this.cur_customer.id;
          this.edit_contract.fill_user = this.cur_customer.account;
        }
        this.edit_config.modal = true;
      },
      setQuantitativeOutput(contract) {
        const {quantitative_output} = (contract || {})
        switch (quantitative_output) {
        case true:
        case false:
          this.edit_contract.quantitative_output = `${quantitative_output}`
          break;
        default:
          this.edit_contract.quantitative_output = ''
          break;
        }
      },
      handleParams(contract) {
        contract = contract || {}
        change_fields.forEach(key => {
          if (key !== 'customer_function_id') {
            delete contract[key]
          }
        })
        return contract
      },
      edit(contract) {
        this.loading = true;
        OSUtil.getDetail(contract.id).then((data) => {
        
        
          this.edit_contract = this.handleParams(data.contract);
          //  this.edit_contract.ads_record_ids = data.contract.placing_ads_records
          // this.$set(this.edit_contract, 'ads_record_ids', data.contract.placing_ads_records)
        
          this.setQuantitativeOutput(data.contract)
        }).catch((e) => {
          this.$Modal.error({
            title: '提示',
            content: `<p>加载数据失败, 请重试!</p><p>${e.message}</p>`
          });
          this.edit_config.modal = false;
        }).finally(() => {
          this.loading = false;
        });
        this.edit_config.loading = false;
        this.edit_config.modal = true;
      },
      storeFile(contract) {
        this.loading = true;
        OSUtil.getDetail(contract.id).then((data) => {
          this.edit_contract = this.handleParams(data.contract);
          this.setQuantitativeOutput(data.contract)
        }).catch((e) => {
          this.$Modal.error({
            title: '提示',
            content: `<p>加载数据失败, 请重试!</p><p>${e.message}</p>`
          });
          this.store_file_config.modal = false;
        }).finally(() => {
          this.loading = false;
        });
        this.store_file_config.modal = true;
      },
      getExpenseTypeName(id) {
        const expense_type = this.expense_types_hash[id];
        return expense_type ? expense_type.full_name : '-';
      },
      trimSpace(key) {
        this.edit_contract[key] = this.edit_contract[key].trim();
      },
      stripSpace(key) {
        this.edit_contract[key] = this.edit_contract[key].replace(/\s/g, '');
      },
      checkValid() {
        let msg = '';
        if (!this.edit_contract.apply_user_id) {
          msg += '<p>[申请人]不能为空</p>';
        }
        if (!this.edit_contract.pay_user_id) {
          msg += '<p>[负责人]不能为空, 负责人负责给兼职员工提交工资申请</p>';
        }
        if (!this.edit_contract.fill_user_id) {
          msg += '<p>[填制人]不能为空(如无法操作, 请联系开发)</p>';
        }
        if (!this.edit_contract.account) {
          msg += '<p>[姓名]不能为空</p>';
        }
        // if(!this.edit_contract.region){
        //     msg += '<p>请选择[地区属性]</p>';
        // }
        // if(!this.edit_contract.mobile){
        //     msg += '<p>[联系电话]不能为空</p>';
        // }
        // if(!this.edit_contract.id_number){
        //     msg += '<p>[证件号码]不能为空</p>';
        // }
        // if(this.edit_contract.region === 'mainland'){
        //     if(!Util.IDCheck(this.edit_contract.id_number)){
        //         msg += '<p>请填写正确的[证件号码]</p>';
        //     }
        // }
        // if(!this.edit_contract.company_id){
        //     msg += '<p>请选择[合同签署公司]</p>';
        // }
        // if(!this.edit_contract.team_id){
        //     msg += '<p>请选择[团队]</p>';
        // }
        // if(!this.edit_contract.job_content){
        //     msg += '<p>请选择[工作内容]</p>';
        // }
        // if(!this.edit_contract.settlement_type){
        //     msg += '<p>请选择[结算方式]</p>';
        // }
        // if(!this.edit_contract.payment_type){
        //     msg += '<p>请选择[支付方式]</p>';
        // }
        // if(this.edit_contract.payment_type === 'alipay' && !this.edit_contract.alipay){
        //     msg += '<p>请填写[支付宝账号]</p>';
        // }
        // if(this.edit_contract.payment_type === 'bank'){
        //     if(!this.edit_contract.bank_number || !this.edit_contract.bank_branch)
        //     msg += '<p>请填写完整的[银行卡信息]</p>';
        // }
        // if(!this.edit_contract.contract_start){
        //     msg += '<p>请选择[生效日期]</p>';
        // }
        // if(!this.edit_contract.contract_end){
        //     msg += '<p>请选择[终止日期]</p>';
        // }
        // if(!this.edit_contract.contract_files.length){
        //     msg += '<p>请上传[合同附件]</p>';
        // }
        // if(!this.edit_contract.id_files.length){
        //     msg += '<p>请上传[身份证/护照]</p>';
        // }
        if (msg) {
          this.$Modal.error({title: '提示', content: msg});
          this.resetEditLoading();
          return false;
        }
        return true;
      },
      setContractOK() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const { fund_usage_id, is_insider_trading, is_soho, id_files, ...params } = this.edit_contract
            // edit_contract.id_files
            if (params.platform === 'yunzhanghu') {
              params.is_soho = is_soho
            }
            if (!params.is_electronic) {
              params.id_files = id_files
            }
            if (params.ads_record_ids && !params.ads_record_ids.length) {
              delete params.ads_record_ids
              // params.ads_record_ids = params.ads_record_ids.map(i => i.id)
            }
            delete params.placing_ads_vas_records
            this.edit_config.loading = true;
            Util.ajax.post(Util.api.update_outsource_contract, params).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                const data = res.data;
                this.edit_config.modal = false;
                this.$emit('update', data.contract);
                this.$Message.success('保存成功!');
                if (res.data.contract.job_content === '广告推广') {
                
                  this.$emit('needTfModal', data.contract)
                }
              } else {
                this.$Modal.error({title: '保存失败', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '保存失败', content: e.message})
            }).finally(() => {
              this.edit_config.loading = false;
            });
          } else {
            this.$Message.error('表单有误，注意检查！')
            this.edit_config.loading = false
          }
        })
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 500);
      },
      setApplyUser(customer) {
        this.edit_contract.apply_user_id = customer.id;
        this.edit_contract.apply_user = customer.account;
      },
      setPayUser(customer) {
        this.edit_contract.pay_user_id = customer.id;
        this.edit_contract.pay_user = customer.account;
      },
      setJobContent(content) {
        // 选择广告推广的时候自动选择 职能: 销售费用-市场 是否量产: 否
        if (content === '广告推广') {
          this.edit_contract.quantitative_output = 'false'
          if (this.filter_customer_functions && Array.isArray(this.filter_customer_functions)) {
            for (const i in this.filter_customer_functions) {
              if (this.filter_customer_functions[i].name === '销售费用-市场') {
                this.edit_contract.customer_function_id = this.filter_customer_functions[i].id
              }
            }
          }
        }
        this.edit_contract.job_content = content;
        this.$nextTick(this.handleMap)
        document.body.click();
      },
      setContractStart(date) {
        this.edit_contract.contract_start = date;
      },
      setContractEnd(date) {
        this.edit_contract.contract_end = date;
      },
      uploadedContractFile(file) {
        this.edit_contract.contract_files.push(file);
      },
      uploadedIdFile(file) {
        this.edit_contract.id_files.push(file);
      },
      uploadedPaymentFile(file) {
        this.edit_contract.payment_files.push(file);
      },
      uploadedArchiveFile(file) {
        this.edit_contract.archive_files.push(file);
      },
      uploadedArchiveFileOk() {
        Util.ajax.post(Util.api.update_outsource_contract_archive_files, this.edit_contract).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            this.store_file_config.modal = false;
            this.$Message.success('保存成功!');
          } else {
            this.$Modal.error({title: '保存失败', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '保存失败', content: e.message});
        }).finally(() => {
          this.store_file_config.loading = false;
          setTimeout(() => {
            this.store_file_config.loading = true;
          }, 500);
        });
      },
      // 费用nature相关处理
      // expenseNatureMapped(item) {
      //   return this.mapped_expense_nature_hash[item.id];
      // },
      // expenseNatureText(item) {
      //   let text = item.name;
      //   if (item.del) {
      //     text += '(已废弃)';
      //   } else if (!this.expenseNatureMapped(item)) {
      //     text += '(未建立 mapping 关系)';
      //   }
      //   return text;
      // },
      calcAccountAndAnalysisTitle(key) {
        if (key) {
          let index = change_fields.indexOf(key) + 1
          while (index && change_fields[index]) {
            this.edit_contract[change_fields[index]] = null
            index++
          }
        }
        // const params = {
        //   customer_function_id: this.edit_contract.customer_function_id || 0, 
        //   item_type_id: this.edit_contract.item_type_id || 0,
        //   customer_type:[null, undefined, ''].includes(this.edit_contract.customer_type) ? -1 : this.edit_contract.customer_type,
        //   fund_usage_id:0, 
        //   is_insider_trading:false,
        // }
        // const title_mapping = TitleMappingUtil.getByNatureObj({...this.edit_contract, ...params});
        // this.edit_contract.account_title_id = title_mapping.account_title_id;
        // this.edit_contract.analysis_title_id = title_mapping.analysis_title_id;
      },
      commonFilter(id_key, hash_key, equal_keys = []) {
        const list = [];
        const pushed_ids = {};
        const hash = this[hash_key];
        // console.log()
        for (const m of this.title_mappings) {
          const id = m[id_key];
          // if (id === 0) continue;
          if (this.isKeysEqual(m, equal_keys)) {
            if (!pushed_ids[id]) {
              pushed_ids[id] = true;
              const item = hash[id];
              if (item) {
                list.push(item);
              }
            }
          }
        }
        return list;
      },
      isKeysEqual(title_mapping, equal_keys = []) {
        const equal = true;
        for (const key of equal_keys) {
          if ([-1, 0].includes(title_mapping[key]) && ill_val.includes(this.edit_contract[key])) {
            continue
          }
          if (title_mapping[key] !== this.edit_contract[key]) {
            return false;
          }
        }
        return equal;
      },
    }
  }
</script>
